import React from "react";
import { X, Calendar, Coffee, Clock } from "lucide-react";

const statusOptions = [
	{
		value: "busy",
		label: "Busy",
		description: "Show as busy during this event",
		icon: Clock,
	},
	{
		value: "free",
		label: "Free",
		description: "Show as available during this event",
		icon: Calendar,
	},
	{
		value: "tentative",
		label: "Tentative",
		description: "Show as tentatively busy",
		icon: Coffee,
	},
];

const StatusModal = ({ value, onChange, onClose }) => {
	return (
		<>
			{/* Modal Backdrop */}
			<div
				className="fixed inset-0 bg-black/20 dark:bg-black/40 z-[1000] backdrop-blur-sm"
				onClick={onClose}
			/>

			{/* Modal Content */}
			<div className="fixed z-[1001] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white dark:bg-gray-900 rounded-xl shadow-xl">
				{/* Header */}
				<div className="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-800">
					<h2 className="text-xl font-semibold text-gray-900 dark:text-white">
						Event Status
					</h2>
					<button
						type="button"
						onClick={onClose}
						className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full transition-colors"
					>
						<X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
					</button>
				</div>

				{/* Status Options */}
				<div className="p-4 space-y-4">
					{statusOptions.map((option) => {
						const OptionIcon = option.icon;
						return (
							<button
								key={option.value}
								onClick={() => {
									onChange(option.value);
									onClose();
								}}
								className={`w-full flex items-center gap-2 px-4 py-2 rounded-lg text-left transition-colors ${
									value === option.value
										? "bg-blue-50 dark:bg-blue-900/50 text-blue-600 dark:text-blue-400"
										: "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-900 dark:text-gray-100"
								}`}
							>
								<OptionIcon
									className={`w-5 h-5 ${
										value === option.value
											? "text-blue-500 dark:text-blue-400"
											: "text-gray-500 dark:text-gray-400"
									}`}
								/>
								<div>
									<div className="font-medium">{option.label}</div>
									<div className="text-xs text-gray-500 dark:text-gray-400">
										{option.description}
									</div>
								</div>
							</button>
						);
					})}
				</div>

				{/* Footer */}
				<div className="flex justify-end gap-2 p-4 border-t border-gray-100 dark:border-gray-800">
					<button
						type="button"
						onClick={onClose}
						className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800 rounded-lg transition-colors"
					>
						Close
					</button>
				</div>
			</div>
		</>
	);
};

export default StatusModal;
